/**
 * Session-only flag: once a guest dismisses the sign-up banner on any hub, keep it hidden on
 * every hub for the rest of the session so "always available" never becomes "nagging". Not
 * persisted — a fresh launch shows the banner again.
 */

import { create } from 'zustand';

interface GuestBannerDismissState {
  dismissed: boolean;
  dismiss: () => void;
}

export const useGuestBannerDismissStore = create<GuestBannerDismissState>()((set) => ({
  dismissed: false,
  dismiss: () => set({ dismissed: true }),
}));
